import { api } from 'app/api'
import { useCallback, useState } from 'react'
import type { AdditionalSettingsType } from 'app/dataTypes/dishes/additionalSettings'
import { POST_ADDITIONAL_SETTINGS, convertResult, convertParams } from 'app/common/api/requests/food/items/additional_settings/post'

type Options = {
  orgId: string
  dishId: number | null
  onSubmitSuccess?: () => void,
}
export const useAdditionalSettingsMutate = ({ orgId, dishId }: Options) => {
  const [pending, setPending] = useState<boolean>(false)

  const submit = useCallback(async (params: AdditionalSettingsType) => {
    if (!dishId) return
    setPending(true)

    const res = await api.request(POST_ADDITIONAL_SETTINGS, {
      error: 'Не удалось обновить дополнительные настройки',
      params: {
        orgId,
        dishId,
        settings: params
      },
      convertions: {
        convertParams,
        convertResult
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [dishId, orgId])


  return {
    pending,
    submit,
  }
}
